import React from 'react';
import PropTypes from 'prop-types';

import MUIAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

/**
 * TODO: This component was forked fromSubHeader in Wildfire Suite - should see 
 * if we can incorporate some of this logic back into that shared component lib.
 * Major difference here is we want to pass in our own render functions and event emitters.
 * 
 * @param {Object} props - The props for the component
 * @param {Function} props.leftRender - Render function for the left side of the action bar
 * @param {Function} props.rightRender - Render function for the right side of the action bar
 * 
 * @component
 * @example
 * return (
 *   <ActionBar 
 *      leftRender={
 *        () =>
 *          <Stack spacing={2} direction="row" justifyContent="flex-start">
 *            <Tabber
 *              index={tabIndex}
 *              tabs={tabs}
 *              onChange={handleChange}
 *            />
 *          </Stack>
 *      }
 *      rightRender={
 *        () =>
 *          <Stack spacing={2} direction="row" justifyContent="flex-start">
 *            <Button color="secondary" label="Cancel" />
 *          </Stack>
 *      } />
 * )
 */
const ActionBar = ({ leftRender, rightRender  }) => {

  const renderLeft = () => {
    if (rightRender) {
      return (
        <Box sx={{ flexGrow: 1, textAlign: 'left' }}>{leftRender()}</Box>
      );
    }
    return null;
  };

  const renderRight = () => {
    if (rightRender) {
      return (
        <Box sx={{ flexGrow: 1, textAlign: 'right' }}>{rightRender()}</Box>
      );
    }
    return null;
  };

  return (
    <MUIAppBar position="sticky" sx={{ bgcolor: '#FFF' }}>
      <Toolbar sx={{ fontWeight: '700' }} variant="dense">
        {renderLeft()}
        {renderRight()}
      </Toolbar>
    </MUIAppBar>
  );
};

ActionBar.propTypes = {
  leftRender: PropTypes.func,
  rightRender: PropTypes.func,
};

export default ActionBar;
